import { ApiUrls } from '@/common/domain/Endpoints.domain';
import instance from '@/common/service/api/Axios';

export type TSaveUserRequest = {
    send_sms: boolean;
    user_id: string | null;
    user_info: {
        email: string;
        first_name: string;
        last_name: string;
        phone: string;
        phone2?: string;
    };
};

export type TSaveUserResponse = {
    data?: {
        user_id: string;
    };
    success: boolean;
    errors?: string[];
};

export const saveUser = async (payload: TSaveUserRequest): Promise<TSaveUserResponse> => {
    const response = await instance.post<TSaveUserResponse>(ApiUrls.checkout.saveUser, payload);
    return response.data;
};
